/** The small icon buttons under a message. Bigger on touch screens, where they must be easy to hit. */
export const ACTION_BUTTON =
  "inline-flex items-center justify-center rounded-md p-1.5 text-zinc-500 hover:bg-zinc-200 hover:text-zinc-900 disabled:opacity-40 pointer-coarse:p-2.5 dark:hover:bg-zinc-700 dark:hover:text-zinc-100";

export const ACTION_ICON = "size-4 pointer-coarse:size-5";
